// src/services/messageService.ts
import { AxiosResponse } from 'axios';
import apiClient from './apiClient';

/**
 * 指定したチャットのメッセージ履歴取得 API
 * GET: /message/list/<conversation_id>/
 * @param conversationId チャットID
 */
export const getMessageList = async (
  conversationId: number
): Promise<AxiosResponse> => {
  return apiClient.get(`/chat/message/list/${conversationId}/`);
};

/**
 * 会話内メッセージを CSV で取得
 * GET: /chat/message/export/<conversation_id>/
 */
export const exportMessages = async (conversationId: number): Promise<Blob> => {
  const res = await apiClient.get(`/chat/message/export/${conversationId}/`, {
    responseType: 'blob',
  });
  return res.data;
};
